<script setup lang="ts">
import { useRouter } from 'vue-router';
import VisualFailure from './VisualFailure.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';

const router = useRouter();

const goToProjectSelect = () => {
  router.push({ name: 'ProjectSelect' });
};
</script>

<template>
  <VisualFailure>
    <template #title>Project not found.</template>
  </VisualFailure>

  <div class="action-container">
    <ButtonPrimary block @click="goToProjectSelect" data-tn="select-different-site-btn">
      Select a different site
    </ButtonPrimary>
  </div>
</template>

<style lang="less" scoped>
.action-container {
  margin-top: @margin-top-end-of-page-section;
  width: 100%;
}
</style>
